import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/SectorsPage.css";

// Sectors images
import ecommerceImg from "../assets/sectors/ecommerce.jpg";
import academyImg from "../assets/sectors/academy.jpg";
import consultancyImg from "../assets/sectors/consultancy.jpg";
import economyImg from "../assets/sectors/economy.jpg";
import industryImg from "../assets/sectors/industry.jpg";
import constructionImg from "../assets/sectors/construction.jpg";
import technologyImg from "../assets/sectors/technology.jpg";
import servicesImg from "../assets/sectors/services.jpg";
import charityImg from "../assets/sectors/charity.jpg";

// Feedback images
import kingPhoto from "../assets/feedback/kingPhoto.jpg";
import ahmadPhoto from "../assets/feedback/ahmadPhoto.jpg";
import aliPhoto from "../assets/feedback/aliPhoto.jpg";
import huseyinPhoto from "../assets/feedback/huseyinPhoto.jpg";

import diagramImg from "../assets/ADAM HOLDING UNION.png";

// Data
const sectorsPageData = {
  sectors: [
    { 
      id: "ecommerce", 
      name: "Adam Commerce", 
      subName: "ADAM STORE",
      image: ecommerceImg 
    },
    { 
      id: "academy", 
      name: "Adam Education", 
      subName: "ADAM INTERNATIONAL ACADEMY",
      image: academyImg 
    },
    { 
      id: "consultancy", 
      name: "Adam Consultancy", 
      subName: "ADAM SOLUTIONS",
      image: consultancyImg 
    },
    { 
      id: "economy", 
      name: "Adam Economy", 
      subName: "ADAM BANK",
      image: economyImg 
    },
    { 
      id: "industry", 
      name: "Adam Industry", 
      subName: "ADAM INDUSTRIES",
      image: industryImg 
    },
    { 
      id: "construction", 
      name: "Adam Construction", 
      subName: "ADAM EPCM",
      image: constructionImg 
    },
    { 
      id: "technology", 
      name: "Adam Technology", 
      subName: "ADAM INNOVATION",
      image: technologyImg 
    },
    { 
      id: "services", 
      name: "Adam Services", 
      subName: "ADAM ALLIANCE",
      image: servicesImg 
    },
    { 
      id: "charity", 
      name: "Adam Charity", 
      subName: "ADAM FOUNDATION",
      image: charityImg 
    },
  ],

  testimonials: [
    {
      text: "I have dealt with many companies around the world, and when I met Dr. Muhammad Haidar in the Arabian Gulf region—Dubai—and worked with his company, Adam Holding Union, I realized the immense experience they possess...",
      name: "King Zofoa Abubaka",
      title: "King of Babungo",
      photo: kingPhoto
    },
    {
      text: "Delve deeper into Adam Holding Union's mission, values and culture. By researching these elements, you can identify the core principles that guide Adam Holding Union's operations...",
      name: "Ahmad Slaih",
      title: "CEO at Trust",
      photo: ahmadPhoto
    },
    {
      text: "I learned from Adam Holding Union what it means to succeed in project execution. They are the pioneers of Six Sigma in the region...",
      name: "Hüseyin Arvas",
      title: "CEO at Itimat Company",
      photo: huseyinPhoto
    },
    {
      text: "Through many successful joint projects and businesses that my company has implemented with Adam Holding Union in the fields of solar energy, construction, infrastructure...",
      name: "Ali Aydın",
      title: "Kuveyt Turk Bank Manager",
      photo: aliPhoto
    }
  ],

  statistics: [
    { label: "Years of Experience", value: 30 },
    { label: "Countries Across Four Continents", value: 20 },
    { label: "Companies and Partners Worldwide", value: 700 },
    { label: "Skilled Professionals, Engineers, and Experts", value: 300 },
    { label: "Successfully Completed Multi-Sector Projects", value: 200 },
  ]
};

const Counter = ({ value }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const increment = value / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [value]);

  return <h3 className="sectors-counter-value">{count.toLocaleString()}</h3>;
};

const SectorPage = () => {
  return (
    <div className="sectors-page">
      {/* Hero Section */}
      <header className="sectors-hero">
        <div className="sectors-hero-content">
          <h1 className="sectors-hero-title">Our Sectors</h1>
          <p className="sectors-hero-subtitle">
            With our expertise in various sectors, we offer tailor-made services for you. 
            Select the sector you want to explore.
          </p>
        </div>
      </header>

      {/* Statistics Section */}
      <section className="sectors-section sectors-statistics">
        <h2 className="sectors-section-title">Our Global Impact</h2>
        <div className="sectors-stats-grid">
          {sectorsPageData.statistics.map((stat, index) => (
            <div key={index} className="sectors-stat-card">
              <div className="sectors-stat-icon">
                <span className="sectors-stat-number">{index + 1}</span>
              </div>
              <Counter value={stat.value} />
              <p className="sectors-stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Sectors Diagram Section */}
      <section className="sectors-section sectors-diagram">
        <h2 className="sectors-section-title">ADAM (9 X 9) Sectors</h2>
        
        <div className="sectors-diagram-container">
          <div className="sectors-diagram-wrapper">
            <img 
              src={diagramImg} 
              alt="Adam Holding Sectors Diagram" 
              className="sectors-diagram-main" 
            />
            <div className="sectors-diagram-overlay">
              <img 
                src={diagramImg} 
                alt="Adam Holding Sectors Diagram Overlay" 
                className="sectors-diagram-overlay-image" 
              />
              <div className="sectors-diagram-content">
                <h3>9 Integrated Sectors</h3>
                <p>Working in harmony to deliver comprehensive business solutions worldwide</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sectors Grid Section - GÜNCELLENDİ */}
      <section className="sectors-section sectors-grid-section">
        <h2 className="sectors-section-title">Explore Our Sectors</h2>
        <p className="sectors-section-subtitle">
          Each sector represents a pillar of our comprehensive business ecosystem, delivering specialized expertise and integrated solutions.
        </p>
        
        <div className="sectors-grid-container">
          <div className="sectors-grid-three-columns">
            {sectorsPageData.sectors.map((sector) => (
              <Link to={`/sector/${sector.id}`} key={sector.id} className="sectors-card-three">
                <div className="sectors-card-image-container">
                  <img src={sector.image} alt={sector.name} className="sectors-card-image" />
                  <div className="sectors-card-overlay">
                    <span className="sectors-card-explore">Explore →</span>
                  </div>
                </div>
                <div className="sectors-card-content">
                  <h3>{sector.name}</h3>
                  <p className="sectors-card-subname">{sector.subName}</p>
                  <div className="sectors-card-line"></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="sectors-section sectors-testimonials">
        <h2 className="sectors-section-title">Customer Feedback</h2>
        <div className="sectors-testimonials-grid">
          {sectorsPageData.testimonials.map((testimonial, index) => (
            <div key={index} className="sectors-testimonial-card">
              <p className="sectors-testimonial-text">"{testimonial.text}"</p>
              <div className="sectors-testimonial-author">
                <img src={testimonial.photo} alt={testimonial.name} className="sectors-testimonial-photo" />
                <div className="sectors-testimonial-info">
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="sectors-section sectors-cta">
        <div className="sectors-cta-content">
          <h2 className="sectors-cta-title">Ready to Collaborate?</h2>
          <p className="sectors-cta-text">
            Discover how our multi-sector expertise can drive your business forward.
          </p>
          <div className="sectors-cta-buttons">
            <Link to="/contact" className="sectors-btn sectors-btn--primary">
              Contact Us
            </Link>
            <Link to="/about" className="sectors-btn sectors-btn--secondary">
              Learn More About Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SectorPage;